const map = {
	"./2010/Contact/Index.vue": 54977,
	"./2010/Index.vue": 8723,
	"./2010/People/Index.vue": 81329,
	"./2010/Photos/Index.vue": 78773,
	"./2010/Posters/Index.vue": 39030,
	"./2010/Program/Index.vue": 95434,
	"./2010/Registration/Index.vue": 729,
	"./2010/Sponsors/Index.vue": 26987,
	"./2010/Sponsors/MainSponsor.vue": 90831,
	"./2010/Venue/Index.vue": 42051,
	"./2011/Contact/Index.vue": 36808,
	"./2011/Index.vue": 65649,
	"./2011/People/Index.vue": 61812,
	"./2011/Photos/Index.vue": 38688,
	"./2011/Posters/Index.vue": 54329,
	"./2011/Program/Index.vue": 57440,
	"./2011/Registration/Index.vue": 62563,
	"./2011/Sponsors/Index.vue": 85405,
	"./2011/Sponsors/MainSponsor.vue": 59653,
	"./2011/Venue/Index.vue": 48683,
	"./2012/Contact/Index.vue": 31184,
	"./2012/Index.vue": 12689,
	"./2012/People/Index.vue": 36063,
	"./2012/Photos/Index.vue": 7599,
	"./2012/Posters/Index.vue": 27546,
	"./2012/Program/Index.vue": 25690,
	"./2012/Registration/Index.vue": 38605,
	"./2012/Sponsors/Index.vue": 32674,
	"./2012/Sponsors/MainSponsor.vue": 24302,
	"./2012/Venue/Index.vue": 6286,
	"./2013/Contact/Index.vue": 19237,
	"./2013/Index.vue": 49117,
	"./2013/People/Index.vue": 2976,
	"./2013/Photos/Index.vue": 12322,
	"./2013/Posters/Index.vue": 84497,
	"./2013/Program/Index.vue": 52128,
	"./2013/Registration/Index.vue": 51610,
	"./2013/Showcase/Index.vue": 32635,
	"./2013/Showcase/Lightning.vue": 12743,
	"./2013/Showcase/Program.vue": 41391,
	"./2013/Showcase/Stories.vue": 91672,
	"./2013/Showcase/Venue.vue": 85072,
	"./2013/Sponsors/Index.vue": 10759,
	"./2013/Sponsors/MainSponsor.vue": 10864,
	"./2013/Venue/Index.vue": 63499,
	"./2014/Contact/Index.vue": 51604,
	"./2014/Index.vue": 73264,
	"./2014/People/Index.vue": 99129,
	"./2014/Photos/Index.vue": 13505,
	"./2014/Posters/Index.vue": 70613,
	"./2014/Program/Index.vue": 20489,
	"./2014/Registration/Index.vue": 23165,
	"./2014/Showcase/FederationSquare.vue": 75935,
	"./2014/Showcase/Index.vue": 91521,
	"./2014/Showcase/MakingScienceBeautiful.vue": 86380,
	"./2014/Showcase/Masterclass.vue": 58097,
	"./2014/Sponsors/Index.vue": 71099,
	"./2014/Sponsors/MainSponsor.vue": 38875,
	"./2014/Venue/Index.vue": 7942,
	"./2015/Contact/Index.vue": 87168,
	"./2015/Index.vue": 17518,
	"./2015/People/Index.vue": 52103,
	"./2015/Photos/Index.vue": 23180,
	"./2015/Posters/Index.vue": 19820,
	"./2015/Program/Index.vue": 93754,
	"./2015/Registration/Index.vue": 56632,
	"./2015/Showcase/Index.vue": 93109,
	"./2015/Sponsors/Index.vue": 22047,
	"./2015/Sponsors/MainSponsor.vue": 59110,
	"./2015/Venue/Index.vue": 48652,
	"./2016/Contact/Index.vue": 80531,
	"./2016/Index.vue": 49959,
	"./2016/People/Index.vue": 35595,
	"./2016/Photos/Index.vue": 99835,
	"./2016/Posters/Index.vue": 91816,
	"./2016/Program/Index.vue": 79774,
	"./2016/Registration/Index.vue": 55623,
	"./2016/Showcase/Index.vue": 37255,
	"./2016/Sponsors/Index.vue": 33983,
	"./2016/Sponsors/MainSponsor.vue": 70067,
	"./2016/Venue/Index.vue": 97485,
	"./2017/Contact/Index.vue": 89037,
	"./2017/Index.vue": 47436,
	"./2017/People/Index.vue": 67294,
	"./2017/Photos/Index.vue": 45038,
	"./2017/Posters/Index.vue": 48991,
	"./2017/Program/Index.vue": 3015,
	"./2017/Showcase/Evening.vue": 37770,
	"./2017/Showcase/Exhibit.vue": 60264,
	"./2017/Showcase/Index.vue": 73310,
	"./2017/Sponsors/Index.vue": 20731,
	"./2017/Sponsors/MainSponsor.vue": 37805,
	"./2017/Venue/Index.vue": 49370,
	"./2018/Contact/Index.vue": 24038,
	"./2018/Index.vue": 37517,
	"./2018/Masterclass/Index.vue": 9102,
	"./2018/People/Index.vue": 22391,
	"./2018/Photos/Index.vue": 91757,
	"./2018/Posters/Index.vue": 30552,
	"./2018/Program/Index.vue": 74879,
	"./2018/Registration/Index.vue": 19874,
	"./2018/Showcase/Index.vue": 11277,
	"./2018/Showcase/NewYork.vue": 99185,
	"./2018/Showcase/Sydney.vue": 61720,
	"./2018/Sponsors/Index.vue": 60371,
	"./2018/Sponsors/MainSponsor.vue": 22942,
	"./2018/Venue/Index.vue": 4921,
	"./2019/Contact/Index.vue": 47172,
	"./2019/Index.vue": 83681,
	"./2019/People/Index.vue": 34794,
	"./2019/Photos/Index.vue": 49080,
	"./2019/Posters/Index.vue": 61982,
	"./2019/Program/Index.vue": 49271,
	"./2019/Registration/Index.vue": 76506,
	"./2019/Showcase/Index.vue": 95903,
	"./2019/Sponsors/Index.vue": 92368,
	"./2019/Sponsors/MainSponsor.vue": 40454,
	"./2019/Venue/Index.vue": 10987,
	"./2020/Index.vue": 84510,
	"./2020/Sponsors/MainSponsor.vue": 71101,
	"./2021/Contact/Index.vue": 53533,
	"./2021/Index.vue": 67345,
	"./2021/People/Index.vue": 31665,
	"./2021/Photos/Index.vue": 70225,
	"./2021/Platform/Index.vue": 2768,
	"./2021/Posters/Index.vue": 17024,
	"./2021/Program/Index.vue": 66931,
	"./2021/Registration/Index.vue": 75957,
	"./2021/Sponsors/Index.vue": 46821,
	"./2021/Sponsors/MainSponsor.vue": 98592,
	"./2022/Contact/Index.vue": 6792,
	"./2022/Index.vue": 99488,
	"./2022/Masterclass/Index.vue": 99463,
	"./2022/People/Index.vue": 20430,
	"./2022/Photos/Index.vue": 42686,
	"./2022/Platform/Index.vue": 80933,
	"./2022/Posters/Index.vue": 226,
	"./2022/Program/Index.vue": 52849,
	"./2022/Registration/Index.vue": 70313,
	"./2022/Sponsors/Index.vue": 68465,
	"./2022/Sponsors/MainSponsor.vue": 72911,
	"./2022/Workshop/Index.vue": 43953,
	"./2023/Contact/Index.vue": 25262,
	"./2023/Index.vue": 91862,
	"./2023/Masterclass/Index.vue": 26473,
	"./2023/People/Index.vue": 13881,
	"./2023/Photos/Index.vue": 65099,
	"./2023/Posters/Index.vue": 88757,
	"./2023/Program/Index.vue": 61532,
	"./2023/Registration/Index.vue": 25385,
	"./2023/Showcase/Index.vue": 72697,
	"./2023/Sponsors/Index.vue": 75030,
	"./2023/Sponsors/MainSponsor.vue": 92708,
	"./2023/VR/Index.vue": 49235,
	"./2023/Venue/Index.vue": 45860,
	"./2024/Contact/Index.vue": 83792,
	"./2024/Index.vue": 61026,
	"./2024/Masterclass/Index.vue": 94065,
	"./2024/People/Index.vue": 62547,
	"./2024/Photos/Index.vue": 22512,
	"./2024/Posters/Index.vue": 26186,
	"./2024/Program/Index.vue": 33380,
	"./2024/Registration/Form/Index.vue": 40159,
	"./2024/Registration/Index.vue": 76283,
	"./2024/Registration/table-early-bird.vue": 98507,
	"./2024/Registration/table.vue": 2215,
	"./2024/Showcase/Index.vue": 68809,
	"./2024/Sponsors/Index.vue": 42069,
	"./2024/Sponsors/MainSponsor.vue": 84442,
	"./2024/Venue/Index.vue": 54966,
	"./2025/Contact/Index.vue": 94275,
	"./2025/Index copy.vue": 86158,
	"./2025/Index.vue": 26289,
	"./2025/Masterclass/Index.vue": 17627,
	"./2025/People/Index.vue": 79454,
	"./2025/Photos/Index.vue": 99141,
	"./2025/Posters/Index.vue": 40554,
	"./2025/Program/Index.vue": 56680,
	"./2025/Registration/Form/Index.vue": 4838,
	"./2025/Registration/Index.vue": 76104,
	"./2025/Registration/table-early-bird.vue": 78873,
	"./2025/Registration/table.vue": 72918,
	"./2025/Showcase/Index.vue": 98691,
	"./2025/Sponsors/Index.vue": 93159,
	"./2025/Sponsors/MainSponsor.vue": 34820,
	"./2025/Venue/Index.vue": 9462,
	"./2026/Contact/Index.vue": 86701,
	"./2026/Index.vue": 87535,
	"./2026/Masterclass/Index.vue": 24555,
	"./2026/People/Index.vue": 19526,
	"./2026/Photos/Index.vue": 59794,
	"./2026/Posters/Index.vue": 32363,
	"./2026/Program/Index.vue": 64418,
	"./2026/Registration/Index-latest.vue": 13258,
	"./2026/Registration/Index.vue": 52506,
	"./2026/Registration/PostEvent.vue": 35284,
	"./2026/Registration/PreEvent.vue": 59227,
	"./2026/Registration/table-early-bird.vue": 88914,
	"./2026/Registration/table.vue": 28879,
	"./2026/Showcase/Index.vue": 33369,
	"./2026/Sponsors/Index.vue": 17955,
	"./2026/Sponsors/MainSponsor.vue": 16215,
	"./2026/Venue/Index.vue": 53649
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 88787;